<template>
  <div>
    <div>
      <!-- <div
        v-for="(record, index) in recordList"
        :key="index"
      > -->
      <div class="record-card">
        <div class="card-item car-title">
          <div
            class="item-left"
            style="flex: 0 0 89px; color: #383838"
          >
            收支金额：
          </div>
          <div
            class="item-right"
            style="margin-left: 4px"
          >
            ￥{{ record.grantAmt || 0 }}
          </div>
        </div>
        <div class="card-item">
          <div class="item-left">下单时间</div>
          <div class="item-right">
            {{ record.orderTime || "" }}
          </div>
        </div>
        <div class="card-item">
          <div class="item-left">关联单号</div>
          <div class="item-right">
            {{ record.relationNo }}
          </div>
        </div>
        <div class="card-item">
          <div class="item-left">关联车牌号</div>
          <div class="item-right">
            {{ record.carNo || "无车牌" }}
          </div>
        </div>
        <div class="card-item">
          <div class="item-left"> 备注 </div>
          <div class="item-right">
            {{ record.grantRemark || "" }}
          </div>
        </div>
      </div>
    </div>
    <!-- </div>
    <div v-else>
      <div class="blank-wrap">
        <Blank />
      </div>
    </div> -->
  </div>
</template>

<script>
// import Blank from '@/components/blank.vue';

export default {
  components: {
    // Blank
  },
  props: {
    // recordList: {
    //   type: Array,
    //   required: true
    // },
    record: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {};
  },
  onLoad(options) {
    console.log('onLoad:', options);
  },
  onReady() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
.record-card {
  // background: #ffffff;
  // border-radius: 8px;
  // padding: 16px;
  // margin-bottom: 12px;

  .card-item {
    display: flex;
    align-items: center;

    .item-left {
      font-family: PingFangSC-Regular;
      font-size: 16px;
      color: #999999;
      letter-spacing: 0.48px;
      font-weight: 400;
			min-width: 82px;
    }

    .item-right {
      font-family: PingFangSC-Regular;
      font-size: 16px;
      color: #383838;
      letter-spacing: 0.48px;
      font-weight: 400;
      word-break: break-all;
      margin-left: 15px;
    }

    & + .card-item {
      margin-top: 16px;
    }

    &.car-title {
      .item-left {
        font-family: PingFangSC-Medium;
        font-weight: 500;
        color: #383838;
      }

      .item-right {
        font-family: PingFangSC-Medium;
        color: #ff8a59;
        font-weight: 500;
      }
    }
  }
}

.blank-wrap {
  padding-top: 90px;
}
</style>
